define([
    'basecollection',
    'modules/channels/models/channel'
], (BaseCollection, Channel) => BaseCollection.extend({
    model: Channel,
    url: '/channels'
}));
